<template>
  <div class="teacher-login">
    <div class="login-frame">
      <div class="login-title">百项过值班系统</div>
      <div class="login-wrap">
        <el-form  class="admin-form" :model="teacherForm">
          <el-form-item>
            <div class="hint">老师登录</div>
            <el-input
              ref="teacherCode"
              v-model="teacherForm.code"
              @keyup.enter.native="autoFocus('teacherPwd')"
              placeholder="老师登录"
              maxlength="30">
            </el-input>
          </el-form-item>
          <el-form-item>
            <div class="hint">登录密码</div>
            <el-input
              ref="teacherPwd"
              v-model="teacherForm.password"
              @keyup.enter.native="loginTeacher"
              type="password"
              autocomplete="new-password"
              placeholder="登录密码"
              maxlength="30">
            </el-input>
          </el-form-item>
          <el-form-item class="text-ar">
            <el-button @click="loginTeacher" class="btn-login btn-primary" round>
              开始值班
            </el-button>
          </el-form-item>
        </el-form>
        <div class="aftersale">
          <el-popover
            placement="top"
            width="150"
            trigger="click">
            <img class="saler" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/9a0396ac510f870b6267ac233034ce37.jpg" />
            <p slot="reference" class="call"><i class="el-icon-service"></i> 联系客服</p>
          </el-popover>
          <p>客服值班时间：8:30-22:30(全年无休)</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Button,
  Form,
  FormItem,
  Input,
  Popover,
} from 'element-ui';
import utils from '@/services/utils';
import api from '@/api/graphql/teacher';

export default {
  name: 'login',
  components: {
    ElForm: Form,
    ElFormItem: FormItem,
    ElInput: Input,
    ElButton: Button,
    ElPopover: Popover,
  },
  data() {
    return {
      teacherForm: {
        code: '',
        password: '',
      },
    };
  },
  methods: {
    loginTeacher() {
      api.teacherLogin({
        account: this.teacherForm.code,
        password: this.teacherForm.password,
      }).then(({ teacherLogin }) => {
        utils.login(teacherLogin);
        this.$router.replace('student-info');
      });
    },
    autoFocus(name) {
      this.$refs[name].focus();
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/variables.scss';
.teacher-login {
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 1200px;
  min-height: 680px;
  background-size: cover;;
  background-image: url(http://vanthink-oss-qingdao.wxzxzj.com/vued250a971b8218f5ef26683848edcc7b1d.png);
  .login-frame {
    position: absolute;
    top: 23%;
    left: 22%;
    width: 389px;
    height: 445px;
    background-color: #5a5fef;
    border-radius: 20px;
    .login-title {
      padding: 5px 0;
      text-align: center;
      color: #fff;
      font-weight: bold;
      font-size: 20px;
      line-height: 48px;
    }
    .login-wrap {
      height: 357px;
      padding: 60px 30px 0;
      background: #fff;
      border-radius: 20px;
      .hint {
        font-size: 16px;
        letter-spacing: 2px;
        margin-top: 0;
        margin-bottom: 0;
      }
      .admin-form .el-input__inner {
        border-radius: 10px;
        background-color: #f6f5fb;
      }
      .text-ar {
        text-align: center;
        margin-top: 30px;
        .el-button {
          width: 140px;
        }
      }
      .aftersale {
        margin-top: 50px;
        text-align: center;
        color: #898989;
        p {
          margin: 8px 0;
        }
        .call {
          cursor: pointer;
        }
      }
    }
    .btn-login{
      color: #fff;
      background: #5a5fef;
    }
  }
}
.saler {
  width: 100%;
}

</style>
